import { useState } from "react";
import { 
    Container, 
    Box,
    Typography, 
    TextField,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from 'notistack';
import axios from "axios";
import { withPather } from "react-pather";
import Loader from "../Loader";
import { PrimaryButton } from "../general";

const ResetPassword = ({ pather }) => {

    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();

    const [loading, setLoading] = useState();
    const [login, setLogin] = useState('');
    const [isSent, setIsSent] = useState(false);

    const getResetLink = () => {
        setLoading(true);
        axios.post(pather.back.Reset.link, { login })
        .then(response => {
            setIsSent(true);
        })
        .catch(error => {
            if (error?.response?.data?.status) enqueueSnackbar(error.response.data.status, { variant: 'error' });
            else enqueueSnackbar('Something went wrong!', { variant: 'error' });
            console.log(error);
        })
        .finally(() => {
            setLoading(false);
        });
    }

    return (
        <Container sx={{minHeight: '550px', display: 'flex', alignItems: 'center'}}>
            {
                loading ? 
                <Loader/> :
                <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3, mt: {xs: 5, sm: 15}, mb: {xs: 5, sm: 20}}}>
                    {
                        isSent ?
                        <>
                            <Typography
                                component="h1"
                                sx={{
                                    fontSize: '32px'
                                }}
                                gutterBottom
                            >
                                Reset email was sent successfully 
                            </Typography>
                            <Box sx={{width: {xs: '100%', sm: '70%', md: '20vw'}}}>
                                <PrimaryButton text="Return to Login" onClick={() => navigate(pather.front.login)}/>
                            </Box>
                        </> :   
                        <>
                            <Typography
                                component="h1"
                                sx={{
                                    fontSize: '32px'
                                }}
                                gutterBottom
                            >
                                Reset Password
                            </Typography>
                            <Box 
                                sx={{
                                    display: 'flex', 
                                    flexDirection: 'column', 
                                    gap: 2, 
                                    width: {xs: '100%', sm: '70%', md: '30vw'},
                                    maxWidth: '500px',
                                }}
                            >
                                <Box sx={{display: 'flex', flexDirection: 'column', gap: .5}}>
                                    <Typography 
                                        component="div"
                                        sx={{
                                            fontSize: '16px'
                                        }}
                                        gutterBottom
                                    >
                                        Enter email or username for your account.
                                    </Typography>
                                    <TextField 
                                        label="Email or username" 
                                        value={login}
                                        onChange={e => setLogin(e.target.value.trim())} 
                                    /> 
                                </Box>
                                <PrimaryButton text="Get password reset link" onClick={getResetLink}/>
                            </Box>
                        </>
                    }
                </Box>
            }
        </Container>
    );
}

export default withPather()(ResetPassword);